export default [
    {
        path: '/leave-management-worksheet-details',
        name: 'leave-management-worksheet-detail',
        meta: { requiresAuth: true },
        component: () => import('@/pages/leave-management-worksheet-detail/index.vue')
    }
]
